/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import {
  Converter,
  ConverterService,
  EntitiesModel,
  Occ,
} from '@lm-nx-frontend/lm-inf-core';
import {PERMISSION_NORMALIZER} from "../../core/connectors";
import {Permission} from "../../core/model";

@Injectable({
  providedIn: 'root',
})
export class OccPermissionListNormalizer
  implements Converter<Occ.PermissionsList, EntitiesModel<Permission>>
{
  constructor(private converter: ConverterService) {}

  convert(
    source: Occ.PermissionsList,
    target?: EntitiesModel<Permission>
  ): EntitiesModel<Permission> {
    if (target === undefined) {
      target = { ...(source as any) } as EntitiesModel<Permission>;
    }
    target.values =
      source.orderApprovalPermissions?.map((permission) => ({
        ...this.converter.convert(permission, PERMISSION_NORMALIZER),
      })) ?? [];
    return target;
  }
}
